// // // import React from 'react';
// // // import { FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';


// // // import "./Footer.css";


// // // const Footer = () => {
// // //   return (
// // //     <footer className="site-footer">
// // //       {/* Top Section (Multiple Columns) */}
// // //       <div className="footer-top">
// // //         <div className="footer-column">
// // //           <h3>Academic Journal Hub</h3>
// // //           <p>Advancing knowledge through peer-reviewed research publications.</p>
// // //         </div>
// // //         <div className="footer-column">
// // //           <h4>Quick Links</h4>
// // //           <ul>
// // //             <li><a href="/">Home</a></li>
// // //             <li><a href="/submit">Submit Journal</a></li>
// // //             <li><a href="/journals">View Journals</a></li>
// // //             <li><a href="/about">About Us</a></li>
// // //             <li><a href="/contact">Contact</a></li>
// // //           </ul>
// // //         </div>
// // //         <div className="footer-column">
// // //           <h4>Legal</h4>
// // //           <ul>
// // //             <li><a href="/privacy">Privacy Policy</a></li>
// // //             <li><a href="/terms">Terms of Service</a></li>
// // //             <li><a href="/copyright">Copyright Policy</a></li>
// // //           </ul>
// // //         </div>
// // //         <div className="footer-column">
// // //           <h4>Follow Us</h4>
// // //           <ul className="social-links">
// // //             <li><a href="#"><FaFacebook /></a></li>
// // //             <li><a href="#"><FaTwitter /></a></li>
// // //             <li><a href="#"><FaLinkedin /></a></li>

// // //           </ul>
// // //         </div>
// // //       </div>

// // //       {/* Bottom Section */}
// // //       <div className="footer-bottom">
// // //         <p>&copy; {new Date().getFullYear()} Academic Journal Hub. All rights reserved.</p>


// // //         <p>ISSN: <span className="issn">1234-5678</span> | Open Access Peer-Reviewed Publications</p>
// // //       </div>
// // //     </footer>
// // //   );
// // // };

// // // export default Footer;

// // import React from 'react';
// // import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';
// // import { FiMail } from 'react-icons/fi';
// // import "./Footer.css";

// // const Footer = () => {
// //   const currentYear = new Date().getFullYear();

// //   return (
// //     <footer className="site-footer">
// //       <div className="footer-container">
// //         {/* Top Section with Logo and Description */}
// //         <div className="footer-brand">
// //           <h3>Academic Journal Hub</h3>
// //           <p className="footer-tagline">Advancing knowledge through peer-reviewed research publications.</p>
// //           <div className="footer-social-desktop">
// //             <h4>Connect With Us</h4>
// //             <div className="social-icons">
// //               <a href="#" aria-label="Facebook"><FaFacebook size={18} /></a>
// //               <a href="#" aria-label="Twitter"><FaTwitter size={18} /></a>
// //               <a href="#" aria-label="LinkedIn"><FaLinkedin size={18} /></a>
// //               <a href="#" aria-label="Instagram"><FaInstagram size={18} /></a>
// //               <a href="mailto:contact@academicjournalhub.com" aria-label="Email"><FiMail size={18} /></a>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Middle Sections */}
// //         <div className="footer-links-container">
// //           <div className="footer-column">
// //             <h4>Navigation</h4>
// //             <ul className="footer-links">
// //               <li><a href="/">Home</a></li>
// //               <li><a href="/journals">Browse Journals</a></li>
// //               <li><a href="/submit">Submit Research</a></li>
// //               <li><a href="/about">About Us</a></li>
// //               <li><a href="/contact">Contact</a></li>
// //             </ul>
// //           </div>

// //           <div className="footer-column">
// //             <h4>Resources</h4>
// //             <ul className="footer-links">
// //               <li><a href="/author-guidelines">Author Guidelines</a></li>
// //               <li><a href="/peer-review">Peer Review Process</a></li>
// //               <li><a href="/faq">FAQs</a></li>
// //               <li><a href="/open-access">Open Access Policy</a></li>
// //               <li><a href="/citations">Citation Guidelines</a></li>
// //             </ul>
// //           </div>

// //           <div className="footer-column">
// //             <h4>Legal</h4>
// //             <ul className="footer-links">
// //               <li><a href="/privacy">Privacy Policy</a></li>
// //               <li><a href="/terms">Terms of Service</a></li>
// //               <li><a href="/copyright">Copyright Policy</a></li>
// //               <li><a href="/accessibility">Accessibility</a></li>
// //               <li><a href="/ethics">Publication Ethics</a></li>
// //             </ul>
// //           </div>

// //           {/* Social links for mobile view */}
// //           <div className="footer-social-mobile">
// //             <h4>Connect With Us</h4>
// //             <div className="social-icons">
// //               <a href="#" aria-label="Facebook"><FaFacebook size={18} /></a>
// //               <a href="#" aria-label="Twitter"><FaTwitter size={18} /></a>
// //               <a href="#" aria-label="LinkedIn"><FaLinkedin size={18} /></a>
// //               <a href="#" aria-label="Instagram"><FaInstagram size={18} /></a>
// //               <a href="mailto:contact@academicjournalhub.com" aria-label="Email"><FiMail size={18} /></a>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Bottom Section with Copyright and ISSN */}
// //       <div className="footer-bottom">
// //         <div className="footer-bottom-container">
// //           <div className="footer-copyright">
// //             <p>&copy; {currentYear} Academic Journal Hub. All rights reserved.</p>
// //           </div>
// //           <div className="footer-info">
// //             <p>ISSN: <span className="issn">1234-5678</span> | Open Access Peer-Reviewed Publications</p>
// //           </div>
// //         </div>
// //       </div>
// //     </footer>
// //   );
// // };

// // export default Footer;

// import React from 'react';
// import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaResearchgate, FaOrcid } from 'react-icons/fa';
// import { FiMail, FiExternalLink } from 'react-icons/fi';
// import "./Footer.css";

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   return (
//     <footer className="site-footer">
//       <div className="footer-container">
//         {/* Top Section with Logo and Description */}
//         <div className="footer-brand">
//           <h3>Academic Journal Hub</h3>
//           <p className="footer-tagline">Advancing knowledge through peer-reviewed research publications across disciplines. A trusted platform for scholarly communication.</p>
//           <div className="footer-social-desktop">
//             <h4>Connect With Us</h4>
//             <div className="social-icons">
//               <a href="#" aria-label="Facebook"><FaFacebook size={16} /></a>
//               <a href="#" aria-label="Twitter"><FaTwitter size={16} /></a>
//               <a href="#" aria-label="LinkedIn"><FaLinkedin size={16} /></a>
//               <a href="#" aria-label="ResearchGate"><FaResearchgate size={16} /></a>
//               <a href="#" aria-label="ORCID"><FaOrcid size={16} /></a>
//               <a href="mailto:contact@academicjournalhub.com" aria-label="Email"><FiMail size={16} /></a>
//             </div>
//           </div>
//         </div>

//         {/* Middle Sections */}
//         <div className="footer-links-container">
//           <div className="footer-column">
//             <h4>Navigation</h4>
//             <ul className="footer-links">
//               <li><a href="/">Home</a></li>
//               <li><a href="/journals">Browse Journals</a></li>
//               <li><a href="/submit">Submit Research</a></li>
//               <li><a href="/about">About Us</a></li>
//               <li><a href="/contact">Contact</a></li>
//             </ul>
//           </div>

//           <div className="footer-column">
//             <h4>Resources</h4>
//             <ul className="footer-links">
//               <li><a href="/author-guidelines">Author Guidelines</a></li>
//               <li><a href="/peer-review">Peer Review Process</a></li>
//               <li><a href="/faq">FAQs</a></li>
//               <li><a href="/open-access">Open Access Policy</a></li>
//               <li><a href="/citation-metrics">Citation Metrics <FiExternalLink size={12} style={{marginLeft: '4px'}} /></a></li>
//             </ul>
//           </div>

//           <div className="footer-column">
//             <h4>Legal</h4>
//             <ul className="footer-links">
//               <li><a href="/privacy">Privacy Policy</a></li>
//               <li><a href="/terms">Terms of Service</a></li>
//               <li><a href="/copyright">Copyright Policy</a></li>
//               <li><a href="/accessibility">Accessibility</a></li>
//               <li><a href="/ethics">Publication Ethics</a></li>
//             </ul>
//           </div>

//           {/* Social links for mobile view */}
//           <div className="footer-social-mobile">
//             <h4>Connect With Us</h4>
//             <div className="social-icons">
//               <a href="#" aria-label="Facebook"><FaFacebook size={16} /></a>
//               <a href="#" aria-label="Twitter"><FaTwitter size={16} /></a>
//               <a href="#" aria-label="LinkedIn"><FaLinkedin size={16} /></a>
//               <a href="#" aria-label="ResearchGate"><FaResearchgate size={16} /></a>
//               <a href="#" aria-label="ORCID"><FaOrcid size={16} /></a>
//               <a href="mailto:contact@academicjournalhub.com" aria-label="Email"><FiMail size={16} /></a>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Section with Copyright and ISSN */}
//       <div className="footer-bottom">
//         <div className="footer-bottom-container">
//           <div className="footer-copyright">
//             <p>&copy; {currentYear} Academic Journal Hub. All rights reserved.</p>
//           </div>
//           <div className="footer-info">
//             <p>ISSN: <span className="issn">1234-5678</span> | Open Access Peer-Reviewed Publications</p>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


import React from 'react';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaResearchgate, FaOrcid } from 'react-icons/fa';
import { FiMail, FiExternalLink } from 'react-icons/fi';
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer bg-blue-900 w-full">
      <div className="footer-container max-w-7xl mx-auto">
        {/* Top Section with Logo and Description */}
        <div className="footer-brand">
          <h3 className="text-xl font-bold tracking-wide">Sahara Journal</h3>
          <p className="footer-tagline">Advancing knowledge through peer-reviewed research publications across disciplines. A trusted platform for scholarly communication.</p>
          <div className="footer-social-desktop">
            <h4>Connect With Us</h4>
            <div className="social-icons">
              <a href="#" aria-label="Facebook"><FaFacebook size={16} /></a>
              <a href="#" aria-label="Twitter"><FaTwitter size={16} /></a>
              <a href="#" aria-label="LinkedIn"><FaLinkedin size={16} /></a>
              <a href="#" aria-label="ResearchGate"><FaResearchgate size={16} /></a>
              <a href="#" aria-label="ORCID"><FaOrcid size={16} /></a>
              <a href="mailto:contact@academicjournalhub.com" aria-label="Email"><FiMail size={16} /></a>
            </div>
          </div>
        </div>

        {/* Middle Sections */}
        <div className="footer-links-container">
          <div className="footer-column">
            <h4>Navigation</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/journals">Browse Journals</a></li>
              <li><a href="/submit">Submit Research</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Resources</h4>
            <ul className="footer-links">
              <li><a href="/author-guidelines">Author Guidelines</a></li>
              <li><a href="/peer-review">Peer Review Process</a></li>
              <li><a href="/faq">FAQs</a></li>
              <li><a href="/open-access">Open Access Policy</a></li>
              <li><a href="/citation-metrics">Citation Metrics <FiExternalLink size={12} style={{marginLeft: '4px'}} /></a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Legal</h4>
            <ul className="footer-links">
              <li><a href="/privacy">Privacy Policy</a></li>
              <li><a href="/terms">Terms of Service</a></li>
              <li><a href="/copyright">Copyright Policy</a></li>
              <li><a href="/accessibility">Accessibility</a></li>
              <li><a href="/ethics">Publication Ethics</a></li>
            </ul>
          </div>

          {/* Social links for mobile view */}
          <div className="footer-social-mobile">
            <h4>Connect With Us</h4>
            <div className="social-icons">
              <a href="#" aria-label="Facebook"><FaFacebook size={16} /></a>
              <a href="#" aria-label="Twitter"><FaTwitter size={16} /></a>
              <a href="#" aria-label="LinkedIn"><FaLinkedin size={16} /></a>
              <a href="#" aria-label="ResearchGate"><FaResearchgate size={16} /></a>
              <a href="#" aria-label="ORCID"><FaOrcid size={16} /></a>
              <a href="mailto:contact@academicjournalhub.com" aria-label="Email"><FiMail size={16} /></a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section with Copyright and ISSN */}
      <div className="footer-bottom bg-blue-800">
        <div className="footer-bottom-container max-w-[1280px] mx-auto">
          <div className="footer-copyright">
            <p>&copy; {currentYear} Sahara Journal. All rights reserved.</p>
          </div>
          <div className="footer-info">
            <p>ISSN: <span className="issn">1234-5678</span> | Open Access Peer-Reviewed Publications</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
